export default "__VITE_ASSET__D2jm1pE9__"